module.exports = __webpack_public_path__ + "Roboto-Light.3b813c2ae0d04909a33a.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/font/roboto/Roboto-Light.woff
// module id = ../../../../../src/font/roboto/Roboto-Light.woff
// module chunks = 1